<template>
	<div class="MainBox" @click.stop="SelectActive(-1,$self)">
    <div class="TableHead">
      <ul class="TableHeadLeft">
        <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius" @click="HandleModel(1,true)"><span class="icon iconfont iconicon-test20"></span>{{$t('b.BatchManage.AddBatch')}}</li>
      </ul>
      <ul class="TableHeadRight">
        <div class="SearchBox">
          <input :placeholder="$t('b.BatchManage.HintOne')" v-model="QueryName" v-on:keyup.13="QueryData" />
          <a class="SearchBtn" @click="QueryData" v-text="$t('c.Common.Search')"></a>
        </div>
      </ul>
      <ul class="clear"></ul>
    </div>

    <div class="TableMain">
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
      <table class="table StripeTable" v-else>
        <thead>
          <tr>
            <th v-text="$t('b.BatchManage.BatchName')"></th>
            <th v-if="userType(3)">产品名称</th>
            <th v-text="$t('b.BatchManage.QualityStatus')"></th>
            <th v-text="$t('b.BatchManage.LogisticsStatus')"></th>
            <th v-if="!userType(3)" v-text="$t('c.Common.Remarks')"></th>
            <th v-text="$t('c.Common.CreationTime')"></th>
            <th v-text="$t('c.Common.Operation')"></th>
          </tr>
        </thead>
        <tbody class="TRHoverStyle">
          <tr v-for="(item,index) in datas" v-bind:key="index">
            <td v-text="item.name"></td>
            <td v-if="userType(3)" v-text="item.intro"></td>
            <td class="slidebtnBox">
              <span v-if="item.qc" class="icon iconfont iconicon-test61 whether blueColor"></span>
              <span v-else class="icon iconfont iconicon-test62 whether"></span>
            </td>
            <td class="slidebtnBox">
              <span v-if="item.express" class="icon iconfont iconicon-test61 whether blueColor"></span>
              <span v-else class="icon iconfont iconicon-test62 whether"></span>
            </td>
            <td v-if="!userType(3)" v-text="item.remark"></td>
            <td v-text="item.created_at"></td>
            <td>
              <div class="btnArray">
                <a class="btnStyleTwo btnRadius blueBackColor" @click="GoToPage('QualityInformation?id='+item.batch_id)" v-text="$t('b.BatchManage.QualityInformation')"></a>
                <a class="btnStyleTwo btnRadius cyanBackColor" @click="HandleModel(2,true,item)" v-text="$t('b.BatchManage.LogisticsInformation')"></a>
                <a class="btnStyleTwo btnRadius redTwoBackColor" @click="GoToPage('DemoProcess?id='+item.batch_id)">演示溯源</a>
                <a v-if="userType(3)" class="btnStyleTwo btnRadius greenBackColor" @click="HandleModel(3,true, item)">详情</a>
                <a v-if="!userType(3)" class="btnStyleTwo btnRadius greenBackColor" @click="HandleModel(1,true, item)" v-text="$t('c.Common.Edit')"></a>
                <a v-if="!userType(3)" class="btnStyleTwo btnRadius redBackColor" @click="RemoveData(item.batch_id)" v-text="$t('c.Common.Delete')"></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- 分页器 -->
      <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

      <!-- 批次添加 -->
      <div class="ModalBox"  v-if="ModelShow" style="overflow-x: auto;padding: 0 10px;box-sizing: border-box;">
        <div class="ModalMain" style="width: auto;">
          <div class="ModalMainHead">
            {{$t('b.BatchManage.AddBatch')}}
            <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback" @click="HandleModel(1,false)"></span>
          </div>
          <div v-if="userType(3)" class="ModalMainBox" style="display: flex">
            <div style="flex: 1; margin-right: 50px;" class="FormStyleTwoLeft ">
              <ul  class="FormStyleTwo">
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>产品名称</p>
                <p>
                  <el-select v-model="FormData.production_id" placeholder="请选择">
                    <el-option
                        v-for="(item, index) in SelectArr[2].datas"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>规格型号</p>
                <p>
                  <input class="form-control" v-model="FormData.model" >
                </p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>最小追溯单元（例：批次、箱、盒、单个产品）</p>
                <p>
                  <input placeholder="" class="form-control" v-model="FormData.minSalesUnit" >
                </p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>生产数量</p>
                <p>
                  <input class="form-control" v-model="FormData.batchNumber" >
                </p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>数字身份码数量</p>
                <p>
                  <input placeholder="" class="form-control" v-model="FormData.certNumber" >
                </p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>批次号</p>
                <p>
                  <input class="form-control" v-model="FormData.batchNo" >
                </p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>批次名称</p>
                <p><input :placeholder="$t('b.BatchManage.HintTwo')" v-model="FormData.name" /></p>
              </li>
              <li class="FormStyleTwoRow" v-show="false">
                <p class="FormStyleTwoTitle"><i>*</i>二维码类型</p>
                <p>
                <div class="SelectStyle" @click.stop="SelectActive(5,$self)">
                  {{SelectArr[5].datas[SelectArr[5].ix]}}
                  <ul class="OptionStyleBox" v-if="SelectArr[5].active">
                    <li class="OptionStyleRow" v-for="(item,index) in SelectArr[5].datas" v-bind:key="index" v-text="item" @click="SelectData(5, index)"></li>
                  </ul>
                  <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
                </div>
                </p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>检查报告地址</p>
                <p>
                  <viewer @inited="inited" ref="viewer">
                    <!-- <input placeholder="检查报告地址" class="form-control" v-model="FormData.reportSrc" > -->
                    <li class="FormStyleTwoImgBox FormStyleTwoRow">
                      <div class='FormStyleTwoImg backImg' v-if="FormData.reportSrc" :style="{backgroundImage: 'url(' + FormData.reportSrc + ')'}">
                        <img v-if="FormData.reportSrc" class="tableImgShow" :src="FormData.reportSrc" @click="PreviewImgs">
                        <span class="icon iconfont iconicon-test33 RemoveImgIcon" @click.stop="RemoveImg"></span>
                      </div>
                      <div class='FormStyleTwoImg backImg' v-else></div>
                      <div class="FormStyleTwoImgMore">
                        <p class="hint" style="width:230px">上传经销商图片不能大于2M，格式为 JPG、PNG或GIF</p>
                        <p class="btnStyleTwo btnRadius blueBackColor" style="display:table;" @click="HandleModel(4, true)">上传图片</p>
                      </div>
                    </li>
                  </viewer>
                </p>
              </li>
            </ul>
            </div>
            <div style="flex: 1;min-width: 380px; margin-right: 50px;" class="FormStyleTwoRight ">
              <ul  class="FormStyleTwo">
                <li class="FormStyleTwoRow">
                  <p class="FormStyleTwoTitle"><i>*</i>生产日期类型</p>
                  <p>
                    <el-select v-model="FormData.productDateType" placeholder="请选择">
                      <el-option
                          v-for="(item, index) in SelectArr[4].datas"
                          :key="index"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </p>
                </li>
                <li class="FormStyleTwoRow" v-show="FormData.productDateType==0">
                  <p class="FormStyleTwoTitle"><i>*</i>生产日期</p>
                  <p>
                    <el-date-picker type="date" placeholder="检验日期" v-model="FormData.productDate" value-format="yyyy-MM-dd"> </el-date-picker>
                  </p>
                </li>
                <li class="FormStyleTwoRow">
                  <p class="FormStyleTwoTitle"><i>*</i>失效类型</p>
                  <p>
                    <el-select v-model="FormData.expireType" placeholder="请选择">
                      <el-option
                          v-for="(item, index) in SelectArr[3].datas"
                          :key="index"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </p>
                </li>
                <li class="FormStyleTwoRow" v-show="FormData.expireType==0">
                  <p class="FormStyleTwoTitle"><i>*</i>失效日期</p>
                  <p>
                    <el-date-picker type="date" placeholder="检验日期" v-model="FormData.expireDate" value-format="yyyy-MM-dd"> </el-date-picker>
                  </p>
                </li>
                <li class="FormStyleTwoRow">
                  <p class="FormStyleTwoTitle">检验日期</p>
                  <p>
                    <el-date-picker type="date" placeholder="检验日期" v-model="FormData.checkDate" value-format="yyyy-MM-dd"> </el-date-picker>
                  </p>
                </li>
                <li class="FormStyleTwoRow">
                  <p class="FormStyleTwoTitle"><i>*</i>检验员</p>
                  <p>
                    <input placeholder="检验员" class="form-control" v-model="FormData.checker" >
                  </p>
                </li>
                <li class="FormStyleTwoRow">
                  <p class="FormStyleTwoTitle">生产人员/班组</p>
                  <p>
                    <input class="form-control" v-model="FormData.producer" >
                  </p>
                </li>
                <li class="FormStyleTwoRow">
                  <p class="FormStyleTwoTitle">生产设备号</p>
                  <p>
                    <input class="form-control" v-model="FormData.equipmentNo" >
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div v-else class="ModalMainBox">
            <ul class="FormStyleTwo">
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>{{$t('c.Common.Name')}}</p>
                <p><input :placeholder="$t('b.BatchManage.HintTwo')" v-model="batch.name" /></p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle">{{$t('c.Common.Remarks')}}</p>
                <p>
                  <textarea :placeholder="$t('b.BatchManage.HintThree')" class="form-control" v-model="batch.remark" ></textarea>
                </p>
              </li>
            </ul>
          </div>
          <div class="ModalMainFoot">
            <!-- <div class="ModalMainFootLeft feedback"><span class="icon iconfont iconicon-test28"></span>{{$t('c.Common.Document')}}</div> -->
            <div class="ModalMainFootRight btnArray">
              <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(1,false)" v-text="$t('c.Common.Cancel')"></a>
              <a v-if="!isDisabled" class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm(1)" v-text="$t('c.Common.Confirm')"></a>
            </div>
          </div>
        </div>
      </div>

      <!-- 物流信息 -->
      <div class="ModalBox" v-if="ModelTwoShow">
        <div class="ModalMain">
          <div class="ModalMainHead">
            {{$t('b.BatchManage.LogisticsInformation')}}
            <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback" @click="HandleModel(2,false)"></span>
          </div>
          <div class="ModalMainBox">
            <ul class="FormStyleTwo">
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle">{{$t('b.BatchManage.LogisticsType')}}</p>
                <p>
                  <div class="SelectStyle" @click.stop="SelectActive(0,$self)">
                    {{$t('b.BatchManage.'+SelectArr[0].datas[SelectArr[0].ix]+'')}}
                    <ul class="OptionStyleBox" v-if="SelectArr[0].active">
                      <li class="OptionStyleRow" v-for="(item,index) in SelectArr[0].datas" v-bind:key="index" v-text="$t('b.BatchManage.'+item+'')" @click="SelectData(0,index)"></li>
                    </ul>
                    <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
                  </div>
                </p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>{{$t('b.BatchManage.LogisticsOrderID')}}</p>
                <p><input :placeholder="$t('b.BatchManage.HintFour')" v-model="express.express_id" /></p>
              </li>
            </ul>
          </div>
          <div class="ModalMainFoot">
            <!-- <div class="ModalMainFootLeft feedback"><span class="icon iconfont iconicon-test28"></span>{{$t('c.Common.Document')}}</div> -->
            <div class="ModalMainFootRight btnArray">
              <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(2,false)" v-text="$t('c.Common.Cancel')"></a>
              <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm(2)" v-text="$t('c.Common.Confirm')"></a>
            </div>
          </div>
        </div>
      </div>

      <!-- 图片空间窗口 -->
    <div class="ModalBox" v-if="ModelThreeShow">
      <div class="ModalMain">
        <div class="ModalMainHead">
          图片空间
          <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback" @click="HandleModel(4, false)"></span>
        </div>
        <div class="TableHead ModalMainImgHead">
          <ul class="TableHeadLeft">
            <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius">
              <span class="icon iconfont iconicon-test20"></span>上传图片
              <input type="file" class="upload" @change="AddImg()" ref="imgs" multiple accept="image/png,image/jpeg,image/gif,image/jpg"/>
            </li>
          </ul>
          <ul class="TableHeadRight">
            <div class="SelectStyle ModalSelect" @click.stop="SelectActive(7,$self)" v-if="SelectArr[7].datas.length > 0">
              <div class="SelectStyleValue">{{SelectArr[7].datas[SelectArr[7].ix].group_name}}</div>
              <ul class="OptionStyleBox" v-if="SelectArr[7].active">
                <ul class="OptionStyleMain">
                  <li class="OptionStyleRow" v-for="(item,index) in SelectArr[7].datas" v-bind:key="index" v-text="item.group_name" @click="SelectData(7,index,item.space_group_id)"></li>
                </ul>
              </ul>
              <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
            </div>
          </ul>
          <ul class="clear"></ul>
        </div>
        <div class="ModalMainBox ModalMainImgBox">
          <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!imgsList"></K-Transition>
          <div v-else :class="{ModalMainBoxScroll:imgsList.length > 5}">
            <table class="table">
              <tbody class="TRHoverStyle">
                <tr v-for="(item,index) in imgsList" v-bind:key="index" @click="selectImg(item.url)">
                  <td class="ModalMaiImgMainBox"><div class="ModalMaiImgMain backImg" :style="{backgroundImage: 'url(' + item.url + ')'}"></div></td>
                  <td v-text="item.name"></td>
                  <td class="ModalMaiImgIconBox"><span class="icon iconfont iconicon-test55 ModalMaiImgIcon"></span></td>
                </tr>
              </tbody>
            </table>
            <!-- 分页器 -->
            <K-Paging :page="imgPage" :totalPages="imgTotalPages" @ChangePage="ChangePageImg" @SkipPage="SkipPageImg"></K-Paging>
          </div>

        </div>
        <div class="ModalMainFoot">
          <div class="ModalMainFootRight btnArray">
            <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(false)">取消</a>
            <a class="btnStyleTwo btnRadius blueBackColor" @click="HandleModel(false)">确定</a>
          </div>
        </div>
      </div>
    </div>

    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

	</div>
</template>

<script>
var self;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
import Confirm from '@/components/common/Confirm.vue'
export default {
  name: 'BatchManage',
  components: {
    'K-Paging': Paging,
    'K-Transition': Transition,
    'K-Confirm': Confirm,
    'K-Loading': Loading,
    'K-Toast': Toast
  },
  data () {
    return {
      $self:null,
      page:1,
      imgPage: 1,
      imgTotalPages: 0,
      id:null,
      subHint:'数据加载中...',
      isDisabled: false,
      isLoding:true,
      loading:false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      Confirm:{
        state:false,
        txt:null
      },
      modelType: 1,
      totalPages:0,
      datas:null,
      ModelShow:false,
      ModelShow2:false,
      ModelTwoShow:false,
      ModelThreeShow:false,
      SelectArr:[{
        ix:0,
        active:false,
        datas:["SFExpress","STOExpress","YTOExpress","YunDaExpress","EMSExpress"]
      },{
        ix:0,
        active:false,
        datas:[]
      },{
        ix:0,
        active:false,
        datas:[]
      },{
        ix:0,
        active:false,
        datas:[{
          label: "指定失效时间",
          value: 0
        },{
          label: "长期有效",
          value: 1
        },{
          label: "详见喷码处",
          value: 2
        }]
      },{
        ix:0,
        active:false,
        datas:[{
          label: "指定生产时间",
          value: 0
        },{
          label: "详见喷码处",
          value: 1
        }]
      },{
        ix:0,
        active:false,
        datas:["一品一码"]
      },{
        ix:0,
        active:false,
        datas:["千克", "吨", "升", "方", "米", "平方米", "套", "件", "辆", "卷", "张"]
      },{
        ix:0,
        active:false,
        datas:[]
      }],
      batch:{},
      express:{},
      QueryName:null,
      pid:0, //分组id
      imgsList:null,
      bkproduction_id: '',
      FormData: {
        name: null,
        production_id: '',
        enterprise_id: 0,
        enterprise_user_id: 0,
        productDateType: 0,
        expireType: 0,
        barcode: null,
        productCode: null,
        batchNo: null,
        batchNumber: null,
        certNumber: null,
        checkDate: null,
        checker: null,
        equipmentNo: null,
        expireDate: null,
        minSalesUnit: null,
        model: null,
        producer: null,
        productDate: null,
        qrCodeType: null,
        reportSrc: null,
        intro: '',
      }
    }
  },
  created () {
    self = this;
    self.$self = this;
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
    self.FormData.enterprise_user_id = self.getSafeCode('enterprise_user_id');
    self.FormData.enterprise_id = self.getSafeCode('enterprise_id');
    self.GetList();
    self.GetProductList();
    self.GetPacketList();
    self.GetImgsList();
  },
  methods: {
    initFormData(){
      this.FormData = {
        name: null,
        production_id: this.bkproduction_id,
        enterprise_id: 0,
        enterprise_user_id: 0,
        productDateType: 0,
        expireType: 0,
        barcode: null,
        productCode: null,
        batchNo: null,
        batchNumber: null,
        certNumber: null,
        checkDate: null,
        checker: null,
        equipmentNo: null,
        expireDate: null,
        minSalesUnit: null,
        model: null,
        producer: null,
        productDate: null,
        qrCodeType: null,
        reportSrc: null,
        intro: '',
      }
    },
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    GetProductList() {
      axios({
        method: "post",
        url: self.GetServerUrl(1) + "production_list_condition",
        data: {no_page: true}
      }).then(function (response) {
        if(response.data?.meta){
          self.SelectArr[2].datas = response.data.meta.map(item=>{
            return {
              label: item.name,
              value: item.production_id,
              code: item.product_sz_code,
            }
          });
          self.FormData.production_id = self.SelectArr[2].datas[0].value;
          self.bkproduction_id = self.SelectArr[2].datas[0].value;
        }
      }).catch(function (error) {
        self.ToastFun(2, self.ErrorHint(error));  //弹窗提醒
      })
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    ChangePage (data) {  //上下翻页
      if(data.te == 1){
        if(self.page > 1){
          self.page--
        }
      }else{
        if(self.page < self.totalPages){
          self.page++
        }
      }
      self.GetList();
    },
    SkipPage (data) {  //跳转分页
      self.page = data.ix;
      self.GetList();
    },
    ChangePageImg (data) {  //上下翻页
      if(data.te == 1){
        if(self.imgPage > 1){
          self.imgPage--
        }
      }else{
        if(self.imgPage < self.imgTotalPages){
          self.imgPage++
        }
      }
      self.GetImgsList();
    },
    SkipPageImg (data) {  //跳转分页
      self.imgPage = data.ix;
      self.GetImgsList();
    },
    zsData(status, batch_id) {
      self.ModelShow2 = status;
      self.datas.forEach((item) => {
        if (item.batch_id === batch_id) {
          console.log();
        }
      });
    },
    HandleModel (te,status,data) {  //隐藏显示生码模态框
      this.modelType = te;
      if(te == 1){
        this.initFormData();
        if(this.userType(3) && !self.SelectArr[2].datas.length){
          self.ToastFun(2, '请先添加产品');
          return;
        }

        self.ModelShow = status;
        self.isDisabled = false;
        if(data){
          self.batch.batch_id = data.batch_id;
          self.batch.name = data.name;
          self.batch.remark = data.remark;
        }else{
          self.batch.batch_id = null;
          self.batch = {};
        }
      } else if(te == 2){
        self.ModelTwoShow = status;
        if(data){
          self.express.batch_id = data.batch_id;
          if(data.express){
            self.SelectArr[0].ix = data.express;
          }
          self.express.express_id = data.express_id;
        }else{
          self.SelectArr[0].ix = 0;
          self.express_id = null;
        }
      } else if(te === 3){
        self.ModelShow = status;
        self.isDisabled = true;
        if(data){
          console.log(data);
          self.FormData.batch_id = data.batch_id;
          self.FormData.name = data.name;
          self.FormData.expireType = data.batch_ext.expireType;
          self.FormData.batchNumber = data.batch_ext.batchNumber;
          self.FormData.certNumber = data.batch_ext.certNumber;
          self.FormData.checkDate = data.batch_ext.checkDate;
          self.FormData.checker = data.batch_ext.checker;
          self.FormData.equipmentNo = data.batch_ext.equipmentNo;
          self.FormData.expireDate = data.batch_ext.expireDate;
          self.FormData.minSalesUnit = data.batch_ext.minSalesUnit;
          self.FormData.model = data.batch_ext.model;
          self.FormData.producer = data.batch_ext.producer;
          self.FormData.production_id = data.batch_ext.production_id;
          self.FormData.productDate = data.batch_ext.productDate;
          self.FormData.productDateType = data.batch_ext.productDateType;
          self.FormData.qrCodeType = data.batch_ext.qrCodeType;
          self.FormData.reportSrc = data.batch_ext.reportSrc;
          self.FormData.batchNo = data.batch_ext.batchNo;
        }else{
          self.batch.batch_id = null;
          self.batch = {};
        }
      }else if(te === 4){
        self.ModelThreeShow = status;
      }
    },
    SubmitForm (te) {  //提交表单
      if(te == 1){
        self.BatchSubmit();
      }else if(te == 2){
        self.ExpressSubmit();
      }
    },
    SwicthSlide (te,ix) {
      if(te == 1){
        if(self.datas[ix].isQuality){
          self.datas[ix].isQuality = false;
        }else{
          self.datas[ix].isQuality = true;
        }
      }else{
        if(self.datas[ix].isExperss){
          self.datas[ix].isExperss = false;
        }else{
          self.datas[ix].isExperss = true;
        }
      }
    },
    SelectData (ix,six) {  //选中选择框内容
      self.SelectArr[ix].ix = six;

      if (ix === 0) {
        self.imgPage = 1;  //重置页数
        self.imgTotalPages = 0;  //清空分页总数
        self.pid = id;  //清楚分组ID
        self.imgsList = null;  //清除图片列表
        self.GetImgsList();  //获取空间图片列表
      }
    },
    GetList () {
      self.datas = null;
      self.isLoding = true;
      axios.get(self.GetServerUrl(1)+"batch_list/"+self.page)
      .then(function (response){
        self.datas = response.data.meta.data;
        self.isLoding = false;

        //总页数
        self.totalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    BatchSubmit () {
      let type;
      let method = 'batch';
      let postData = self.batch;
      if(self.batch.batch_id){
        type = "patch"
      } else if (self.userType(3)) {
        const productItem = self.SelectArr[2].datas.filter(item=>{
          return item.value == self.FormData.production_id;
        })[0]
        self.FormData.intro = productItem.label;
        self.FormData.productCode = productItem.code;
        self.FormData.qrCodeType = self.SelectArr[5].ix + 2;
        if (self.FormData.expireType === 0 && !self.FormData.expireDate) {
          self.ToastFun(2, '失效日期必填');
          return;
        }
        if (self.FormData.productDateType === 0 && !self.FormData.productDate) {
          self.ToastFun(2, '生产日期必填');
          return;
        }
        if (!self.FormData.batchNo) {
          self.ToastFun(2, '批次号必填');
          return;
        }
        if (!self.FormData.batchNumber) {
          self.ToastFun(2, '批量必填');
          return;
        }
        if (!self.FormData.certNumber) {
          self.ToastFun(2, '合格证数量必填');
          return;
        }
        if (!self.FormData.checker) {
          self.ToastFun(2, '检验员必填');
          return;
        }
        if (!self.FormData.model) {
          self.ToastFun(2, '规格型号必填');
          return;
        }
        if (!self.FormData.reportSrc) {
          self.ToastFun(2, '检查报告地址必填');
          return;
        }
        postData = self.FormData;
        method = "safeCodeBatch";
        type = "post"
      } else {
        type = "post"
      }

      self.loading = true;
      axios({
        method: type,
        url:self.GetServerUrl(1) + method,
        data: postData,
      }).then(function (response) {
        self.ModelShow = false;
        self.loading = false;
        self.ToastFun(0,response.data.message);  //弹窗提醒
        self.GetList();
      }).catch(function (error) {
        self.loading = false;
        self.ToastFun(2,self.ErrorHint(error));  //弹窗提醒
      })
    },
    ExpressSubmit () {
      self.loading = true;
      self.express.express = self.SelectArr[0].ix;
      axios({
        method:"patch",
        url:self.GetServerUrl(1)+"batch",
        data:self.express,
      }).then(function (response) {
        self.ModelTwoShow = false;
        self.loading = false;
        self.ToastFun(0,response.data.message);  //弹窗提醒
        self.GetList();
      }).catch(function (error) {
        self.loading = false;
        self.ToastFun(2,self.ErrorHint(error));  //弹窗提醒
      })
    },
    QueryData () {
      self.isLoding = true;
      axios.post(self.GetServerUrl(1)+"batch_list_condition",{name:self.QueryName})
      .then(function (response){
        self.datas = response.data.meta.data;
        self.isLoding = false;

        //总页数
        self.totalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
        self.datas = null;
      })
    },
    RemoveData (id) {
      self.id = id;
      self.Confirm.state = true;
      self.Confirm.txt = "是否确定删除该批次？"
    },
    ConfirmBackFun (data) {
      self.Confirm.state = data.state;
      if(data.state){
        self.Confirm.state = false;
        self.loading = true;

        axios({
          method:"delete",
          url:self.GetServerUrl(1)+"batch/"+self.id,
        }).then(function (response) {
            self.loading = false;
            self.ToastFun(0,response.data.message);  //弹窗提醒
            self.GetList();
        }).catch(function (error) {
          self.loading = false;
          self.ToastFun(2,self.ErrorHint(error));  //弹窗提醒
        })
      }
    },
    GetPacketList (id) {
      axios.get(self.GetServerUrl(1)+"space_group_list/img")
      .then(function (response){
        self.SelectArr[7].datas = response.data.meta
        self.SelectArr[7].datas.unshift({space_group_id:0,group_name:"默认分组"});
      }).catch(function (error){
        self.SelectArr[7].datas.unshift({space_group_id:0,group_name:"默认分组"});
      })
    },
    GetImgsList () {
      self.isLoding = true;
      axios.get(self.GetServerUrl(1)+"resource/img/"+self.pid+"/"+self.imgPage)
      .then(function (response){
          let datas = [];
          for(let item in response.data.meta.data){
            datas.push(response.data.meta.data[item])
            datas[item].active = false;
          }
          self.imgsList = datas;
          self.isLoding = false;

          //总页数
          self.imgTotalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
        self.imgsList = null;
      })
    },
    AddImg () {
      self.loading = true;

      let inputDOM;
      inputDOM = this.$refs.imgs;
      self.fileLength = inputDOM.files.length;

      //FormDatas格式提交
      let FormDatas = new FormData();
      FormDatas.append("type","img");
      FormDatas.append("space_group_id",self.pid);
      for(let i=0;i< inputDOM.files.length;i++){
        FormDatas.append("resource[]",inputDOM.files[i]);
      }

      axios({
        method:"post",
        url:self.GetServerUrl(1)+"resource",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data:FormDatas
      }).then(function (response) {
          self.loading = false;
          if(self.fileLength > response.data.meta.length){
            self.ToastFun(2,"文件必须为图片格式");  //弹窗提醒
          }else{
            self.ToastFun(0,response.data.message);  //弹窗提醒
          }
          self.GetImgsList();
      }).catch(function (error) {
          self.loading = false;
          self.ToastFun(2,self.ErrorHint(error));  //弹窗提醒
      })
    },
    selectImg (img) {
      self.FormData.reportSrc = img;
      self.HandleModel(4, false);
    },
    RemoveImg () {
      self.FormData.reportSrc = null;
    },
    inited (viewer) {
      self.$viewer = viewer
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    }
  }
}
</script>

<style scoped>
  .iconicon-test38{
    font-size:15px !important;
  }
  input{
    width: 380px;
    box-sizing: border-box;
  }
  :deep .el-input__inner {
    width: 380px !important;
  }
  .FormStyleTwoCustom{
    position: relative;
    margin-bottom: 20px;
  }
  .FormStyleTwoCustomBtnArr{
    position: absolute;
    right:0;
    bottom:2px;
    overflow: hidden;
  }
  .FormStyleTwoCustomBtnArr a{
    width:80px;
    text-align: center;
    display: block;
    float: left;
    height: 35px;
    line-height:35px;
    cursor: pointer;
  }
  .FormStyleTwoUpImg{
    margin-right:10px;
  }
  .FormStyleTwoCenterBtn{
    display: table;
    margin:0 auto;
  }
  .FormStyleTwoCenterBtn a{
    margin-right:5px;
    position: relative;
    top:1px;
  }
</style>
